<template>
  <div class="c-dashboard-body">
    <slot></slot>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss"></style>
